import { LockButtonOverlay } from './Lock/ButtonOverlay'
import { LockOverlay } from './Lock/Overlay'
import { Rewards } from './Rewards'
import { Root } from './Root'
export { useResourceContext } from './context'

export const withResourceRoot = Component => {
  const WrappedComponent = props => {
    return (
      <Root {...props}>
        <Component {...props} />
      </Root>
    )
  }
  WrappedComponent.displayName = `withResourceRoot(${
    Component.displayName || Component.name || 'Component'
  })`
  return WrappedComponent
}

export const Resource = {
  Root,
  LockButtonOverlay,
  LockOverlay,
  Rewards
}
